module.exports = __webpack_public_path__ + "static/Lab-3fa89b784ed8d40151386507f9bc51cb.svg";